import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";

const initialState = {
    institutions: [],
    institutionsWithID: [],
    loading: false,
    error: null,
};

export const getInstitutionsList = createAsyncThunk(
    "institutionsList",
    async (user) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.backoffice;
            const endpointpath = endpoint?.backoffice?.getinstitutionlist;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            throw error.response;
        }
    }
);

const institutionsListSlice = createSlice({
    name: "institutions list",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getInstitutionsList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getInstitutionsList.fulfilled, (state, action) => {
                state.loading = false;
                state.institutions = action?.payload || [];
                state.institutionsWithID = action?.payload ? action?.payload?.map(({ id, label, value }) => ({ label, value: id, code: value })) : [];
            })
            .addCase(getInstitutionsList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default institutionsListSlice.reducer;